<template>
	<div>
		<form class="mx-auto text-center" @submit.prevent="login">
			<img height="50" src="../../images/dashboard/logo_shayah.png">
			<h2 class="text-center font-weight-light">
				Login
			</h2>

			<div class="form-group text-left">
				<label for="username">
					<small class="text-muted">USERNAME</small>
				</label>
				<input type="text" class="form-control" placeholder="Username" v-model="username" required autofocus>
			</div>

			<div class="form-group text-left">
				<label for="password">
					<small class="text-muted">PASSWORD</small>
				</label>
				<input type="password" class="form-control" placeholder="Password" v-model="password" required>
			</div>

			<button type="submit" class="btn btn-primary mt-3 d-block mx-auto w-100 ld-ext-right" :disabled="loading" :class="{running: loading}">
				{{ loading ? 'LOADING…' : 'SUBMIT' }}
				<div class="ld ld-ring ld-spin" />
			</button>

			<div class="alert alert-danger mt-4" v-if="!loading && error">
				<p class="mb-0 text-center">
					{{ error }}
				</p>
			</div>
		</form>
	</div>
</template>

<script>
	import {getError} from '../../helpers';

	export default {
		data() {
			return {
				username: '',
				password: '',
				loading: false,
				error: '',
			};
		},

		methods: {
			login() {
				this.loading = true;

				this.$store.dispatch('auth/login', {
					username: this.username,
					password: this.password,
				}).then(() => {
					this.$router.push({name: 'statistics'});
				}).catch(e => {
					this.error = getError(e);
				}).finally(() => {
					this.loading = false;
				});
			},
		},

		meta: {
			title: 'Login',

			meta: [
				{property: 'og:title', content: 'Login / The Chair'},
			],
		},
	};
</script>


<style scoped>
	form {
		max-width: 320px;
		padding: 2rem;
	}
</style>